import { Link } from "@mui/material";

import { APP_V2_USER_EVENTS, logEvent } from "../lib/analytics";
import { type SupportArticle } from "./types";

interface SupportArticleLinkProps {
  supportArticle: SupportArticle;
}

export function SupportArticleLink(props: SupportArticleLinkProps) {
  const { supportArticle } = props;

  return (
    <Link
      href={supportArticle.attributes.distributionUrl}
      target="_blank"
      rel="noopener noreferrer"
      underline="hover"
      variant="body2"
      onClick={() => {
        logEvent(APP_V2_USER_EVENTS.HELP_CENTER_ARTICLE_OPENED, {
          id: supportArticle.id,
          title: supportArticle.attributes.title,
          category: supportArticle.attributes.category,
        });
      }}
    >
      {supportArticle.attributes.title}
    </Link>
  );
}
